import React from "react";

export default function ChartPanel(props) {
    return (
        <div className="deu-chart-panel">
            <div className="deu-chart-panel-title">{props.title}</div>
            {props.children}
        </div>
    );
}
